// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* WARNING: This section must be updated if _variables.ts is changed */
/* PERCENTAGE COLOURS */
:host ::ng-deep .content-card-wrapper .charge-calculation-ng-busy {
  overflow: auto;
  max-height: calc(100vh - 315px) !important;
}
:host .filter-section ::ng-deep .mat-select-placeholder {
  color: #aab2c0;
}
:host ::ng-deep .mat-form-field-appearance-legacy .mat-form-field-infix {
  padding-top: 16px;
}
:host ::ng-deep .ng-select.ng-select-focused:not(.ng-select-opened) > .ng-select-container,
:host .ng-select::ng-deep .ng-select-container {
  background-color: transparent;
  border: none;
  box-shadow: none;
}
:host ::ng-deep .ng-clear-wrapper {
  margin-left: 10px;
}
:host ::ng-deep .ng-select .ng-select-container .ng-value-container {
  padding-left: 0;
}

.comments-edit-wrapper {
  height: 190px;
  width: 700px;
}

.coloured-dot {
  height: 35px;
  width: 35px;
}

.charge-table {
  display: table;
  margin-bottom: 0;
}

.checkbox-wrapper {
  height: 15px;
}

.group-header {
  background: #efefef;
  border-top: 1px solid #dee2e6;
}

.add-icon {
  color: #078BCB;
  font-size: 50px;
}

.add-icon-btn:focus {
  outline: none;
}

.icons {
  height: 20px;
  width: 20px;
}

.mat-form-field {
  font-size: 14px;
}

.table-header > span,
.table-summary-headers > span,
.table-summary-totals > span {
  vertical-align: top;
  white-space: normal;
}

.table-header {
  background-color: white;
  position: sticky;
  top: 0;
  z-index: 1;
}

.table-footer {
  background-color: white;
  color: #078BCB;
  position: sticky;
  bottom: -1px;
}

.table-row {
  border-bottom: 1px solid #dee2e6;
  min-height: 52px;
}

.table-summary-totals {
  border-top: 2px solid #dee2e6;
}

.sticky-row {
  top: 60px;
  background: #ffffff;
}

.location,
.substrate,
.coating,
.colour {
  vertical-align: top;
}

.location,
.substrate,
.coating,
.colour,
.difficulty,
.labour,
.units,
.cost-unit,
.cost,
.rate,
.charge,
.profit,
.gp,
.discount {
  width: 7.6%;
  padding-right: 10px;
  display: table-cell;
  white-space: normal;
  word-break: break-word;
}

.discount {
  padding-right: 0;
}

.location {
  min-width: 270px;
}
.location .index {
  width: 120px;
  vertical-align: top;
}
.location .location-label {
  width: calc(100% - 120px);
}

.substrate {
  min-width: 100px;
}

.coating {
  min-width: 100px;
}

.colour {
  min-width: 75px;
}

.difficulty {
  min-width: 110px;
}

.labour {
  min-width: 100px;
}

.units {
  min-width: 120px;
}
.units app-display-input-number {
  display: inline-block;
  margin-right: 40px;
}
.units .unit-type {
  margin-left: -40px;
}

.cost-unit {
  min-width: 100px;
}

.cost {
  min-width: 120px;
}

.rate {
  min-width: 120px;
}

.charge {
  min-width: 120px;
}

.profit {
  min-width: 100px;
}

.gp {
  min-width: 100px;
}

.discount {
  min-width: 100px;
}

.button-group {
  margin-top: 4.3rem;
}

.imitate-angular-material {
  border-bottom: 1px solid #078BCB;
}

.company-select-label {
  font-size: 15px;
  font-weight: 600 !important;
}

.reorder-button {
  position: absolute;
  outline: none;
  right: 10px;
  top: -12px;
}

.select-all-checkbox {
  position: absolute;
  top: 4px;
}

.last-edited {
  border-left: solid #078BCB 5px;
}

.disabled-icon {
  opacity: 0.3;
  pointer-events: none;
}

.svg-icon-edit svg {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/white-labelling/default/_variables.scss","webpack://./src/app/dialog/components/charges/charges.component.scss"],"names":[],"mappings":"AAgDA,sEAAA;AAYA,uBAAA;ACzDC;EACC,cAAA;EACA,0CAAA;AAAF;AAIE;EACC,cDWW;ACbd;AAMC;EACC,iBAAA;AAJF;AAOC;;EAEC,6BAAA;EACA,YAAA;EACA,gBAAA;AALF;AASE;EACC,iBAAA;AAPH;AAUE;EACC,eAAA;AARH;;AAaA;EACC,aAAA;EACA,YAAA;AAVD;;AAaA;EACC,YAAA;EACA,WAAA;AAVD;;AAaA;EACC,cAAA;EACA,gBAAA;AAVD;;AAaA;EACC,YAAA;AAVD;;AAaA;EACC,mBD1BkB;EC2BlB,6BAAA;AAVD;;AAaA;EACC,cD5DS;EC6DT,eAAA;AAVD;;AAaA;EACC,aAAA;AAVD;;AAaA;EACC,YAAA;EACA,WAAA;AAVD;;AAaA;EACC,eAAA;AAVD;;AAgBC;;;EAGC,mBAAA;EACA,mBAAA;AAbF;;AAiBA;EACC,uBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AAdD;;AAiBA;EACC,uBAAA;EACA,cDjGS;ECkGT,gBAAA;EACA,YAAA;AAdD;;AAiBA;EACC,gCAAA;EACA,gBAAA;AAdD;;AAiBA;EACC,6BAAA;AAdD;;AAiBA;EACC,SDlCiB;ECmCjB,mBD1FO;AC4ER;;AAiBA;;;;EAIC,mBAAA;AAdD;;AAiBA;;;;;;;;;;;;;;EAcC,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;AAdD;;AAiBA;EACC,gBAAA;AAdD;;AAiBA;EAEC,gBAAA;AAfD;AAiBC;EACC,YAAA;EACA,mBAAA;AAfF;AAkBC;EACC,yBAAA;AAhBF;;AAoBA;EACC,gBAAA;AAjBD;;AAoBA;EACC,gBAAA;AAjBD;;AAoBA;EACC,eAAA;AAjBD;;AAoBA;EACC,gBAAA;AAjBD;;AAoBA;EACC,gBAAA;AAjBD;;AAoBA;EACC,gBAAA;AAjBD;AAmBC;EACC,qBAAA;EACA,kBAAA;AAjBF;AAoBC;EACC,kBAAA;AAlBF;;AAsBA;EACC,gBAAA;AAnBD;;AAsBA;EACC,gBAAA;AAnBD;;AAsBA;EACC,gBAAA;AAnBD;;AAsBA;EACC,gBAAA;AAnBD;;AAsBA;EACC,gBAAA;AAnBD;;AAsBA;EACC,gBAAA;AAnBD;;AAsBA;EACC,gBAAA;AAnBD;;AAsBA;EACC,kBAAA;AAnBD;;AAsBA;EACC,gCAAA;AAnBD;;AAsBA;EACC,eAAA;EACA,2BAAA;AAnBD;;AAsBA;EACC,kBAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;AAnBD;;AAsBA;EACC,kBAAA;EACA,QAAA;AAnBD;;AAsBA;EACC,8BAAA;AAnBD;;AAsBA;EACC,YAAA;EACA,oBAAA;AAnBD;;AAuBC;EACC,WAAA;AApBF","sourcesContent":["// Core theme colors\n$primary: #078BCB;\n$primary2: #067ab2;\n$primary3: #05699a;\n$selectedBackground: #ebf5ff;\n\n// Colour variables\n$black: #000000;\n$border-colour: #dee2e6;\n$card-border: #dfdfdf;\n$cardBorderGrey: #d9dee8;\n$disabled: #caced5;\n$disabledButtonColor: #7bb3d0;\n$disabled-background: #ececec;\n$form-error: #f84646;\n$highlight: #f5f5f5;\n$hoverHighlight: rgba(35, 31, 32, 0.31);\n$inactive: rgba(255, 0, 0, 0.1);\n$inactiveHighlight: rgba(255, 0, 0, 0.2);\n$kaliber-dark: #414448;\n$link: #2185d0;\n$placeholder: #aab2c0;\n$selectedButton: #002865;\n$subtitle: #a0a2a4;\n$white: #ffffff;\n$cardBorderGrey: #d9dee8;\n\n// Bootstrap Colours\n$secondary: #222222;\n$dark: #7a7a7a;\n$background-light: #efefef;\n$print-page-size: auto;\n\n$danger: #d9534f;\n$muted: #85959f;\n$text-muted: #85959f;\n$success: #61f2b6;\n$warning: #f0ad4e;\n$info: #5bc0de;\n$light: #f8f9fa;\n$light-gray: #d3d3d3;\n$background-dark: #414448;\n$disabled-background: rgba(221, 221, 221, 0.3) !default;\n\n// Common Styles\n$border: 1px solid $border-colour;\n$appComsHeight: 60px;\n\n/* WARNING: This section must be updated if _variables.ts is changed */\n$target: #fcb800;\n$declined: #d11f4b;\n$active: #f77f21;\n$quoteReady: #d299c4;\n$quoteApproved: #7c4795;\n$submitted: #662066;\n$won: #3e9937;\n$lost: #00245e;\n$live: #00b0f0;\n$completed: #a9d18e;\n\n/* PERCENTAGE COLOURS */\n$percentage-green: #15b422;\n$percentage-light-green: #a3d000;\n$percentage-yellow: #fcb000;\n$percentage-red: #ff0000;\n\n// DO NOT USE IF YOU SEE THESE BEING USED. PLEASE REMOVE\n$exportTableHeight: 530px;\n$footerHeight: 60px;\n$height650px: 650px;\n$headerNavHeight: 60px;\n$headerHeight: 42px;\n$inputPercentWidth: 91px;\n$inputDiscountWidth: 126px;\n$exportTableHeight: 530px;\n$incExcTableHeight: 300px;\n$sidebarMenuWidth: 120px;\n$sideNavWidth: 67px;\n$height650px: 650px;\n$headerNavHeight: 60px;\n\n// Image References\n$loginLogo: './assets';\n","@import 'variables';\n\n:host {\n\t::ng-deep .content-card-wrapper .charge-calculation-ng-busy {\n\t\toverflow: auto;\n\t\tmax-height: calc(100vh - 315px) !important;\n\t}\n\n\t.filter-section {\n\t\t::ng-deep .mat-select-placeholder {\n\t\t\tcolor: $placeholder;\n\t\t}\n\t}\n\n\t::ng-deep .mat-form-field-appearance-legacy .mat-form-field-infix {\n\t\tpadding-top: 16px;\n\t}\n\n\t::ng-deep .ng-select.ng-select-focused:not(.ng-select-opened) > .ng-select-container,\n\t.ng-select::ng-deep .ng-select-container {\n\t\tbackground-color: transparent;\n\t\tborder: none;\n\t\tbox-shadow: none;\n\t}\n\n\t::ng-deep {\n\t\t.ng-clear-wrapper {\n\t\t\tmargin-left: 10px;\n\t\t}\n\n\t\t.ng-select .ng-select-container .ng-value-container {\n\t\t\tpadding-left: 0;\n\t\t}\n\t}\n}\n\n.comments-edit-wrapper {\n\theight: 190px;\n\twidth: 700px;\n}\n\n.coloured-dot {\n\theight: 35px;\n\twidth: 35px;\n}\n\n.charge-table {\n\tdisplay: table;\n\tmargin-bottom: 0;\n}\n\n.checkbox-wrapper {\n\theight: 15px;\n}\n\n.group-header {\n\tbackground: $background-light;\n\tborder-top: 1px solid $border-colour;\n}\n\n.add-icon {\n\tcolor: $primary;\n\tfont-size: 50px;\n}\n\n.add-icon-btn:focus {\n\toutline: none;\n}\n\n.icons {\n\theight: 20px;\n\twidth: 20px;\n}\n\n.mat-form-field {\n\tfont-size: 14px;\n}\n\n.table-header,\n.table-summary-headers,\n.table-summary-totals {\n\t> span {\n\t\t// correct for padding of drag and drop indicator\n\t\t// padding-left: 13px;\n\t\tvertical-align: top;\n\t\twhite-space: normal;\n\t}\n}\n\n.table-header {\n\tbackground-color: white;\n\tposition: sticky;\n\ttop: 0;\n\tz-index: 1;\n}\n\n.table-footer {\n\tbackground-color: white;\n\tcolor: $primary;\n\tposition: sticky;\n\tbottom: -1px;\n}\n\n.table-row {\n\tborder-bottom: 1px solid #dee2e6;\n\tmin-height: 52px;\n}\n\n.table-summary-totals {\n\tborder-top: 2px solid #dee2e6;\n}\n\n.sticky-row {\n\ttop: $headerNavHeight; // Display below page header\n\tbackground: $white;\n}\n\n.location,\n.substrate,\n.coating,\n.colour {\n\tvertical-align: top;\n}\n\n.location,\n.substrate,\n.coating,\n.colour,\n.difficulty,\n.labour,\n.units,\n.cost-unit,\n.cost,\n.rate,\n.charge,\n.profit,\n.gp,\n.discount {\n\twidth: 7.6%;\n\tpadding-right: 10px;\n\tdisplay: table-cell;\n\twhite-space: normal;\n\tword-break: break-word;\n}\n\n.discount {\n\tpadding-right: 0;\n}\n\n.location {\n\t// includes min width on .index\n\tmin-width: 270px;\n\n\t.index {\n\t\twidth: 120px;\n\t\tvertical-align: top;\n\t}\n\n\t.location-label {\n\t\twidth: calc(100% - 120px);\n\t}\n}\n\n.substrate {\n\tmin-width: 100px;\n}\n\n.coating {\n\tmin-width: 100px;\n}\n\n.colour {\n\tmin-width: 75px;\n}\n\n.difficulty {\n\tmin-width: 110px;\n}\n\n.labour {\n\tmin-width: 100px;\n}\n\n.units {\n\tmin-width: 120px;\n\n\tapp-display-input-number {\n\t\tdisplay: inline-block;\n\t\tmargin-right: 40px;\n\t}\n\n\t.unit-type {\n\t\tmargin-left: -40px;\n\t}\n}\n\n.cost-unit {\n\tmin-width: 100px;\n}\n\n.cost {\n\tmin-width: 120px;\n}\n\n.rate {\n\tmin-width: 120px;\n}\n\n.charge {\n\tmin-width: 120px;\n}\n\n.profit {\n\tmin-width: 100px;\n}\n\n.gp {\n\tmin-width: 100px;\n}\n\n.discount {\n\tmin-width: 100px;\n}\n\n.button-group {\n\tmargin-top: 4.3rem;\n}\n\n.imitate-angular-material {\n\tborder-bottom: 1px solid $primary;\n}\n\n.company-select-label {\n\tfont-size: 15px;\n\tfont-weight: 600 !important;\n}\n\n.reorder-button {\n\tposition: absolute;\n\toutline: none;\n\tright: 10px;\n\ttop: -12px;\n}\n\n.select-all-checkbox {\n\tposition: absolute;\n\ttop: 4px;\n}\n\n.last-edited {\n\tborder-left: solid $primary 5px;\n}\n\n.disabled-icon {\n\topacity: 0.3;\n\tpointer-events: none;\n}\n\n.svg-icon-edit {\n\tsvg {\n\t\twidth: 100%;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
